<template>
  <div class="question">
    <p class="question-txt">{{questionData.question}}</p>

    <div class="sliders" v-for="(option, index) in questionData.options" :key="index">
      <div class="title">{{ option.title }}</div>
      <div class="row">
        <el-slider
          v-model="questionData.options[index].value"
          :step=".10"
          :min="0"
          :max="1"
          :show-tooltip="false"
          @change="updateStore"
          >
        </el-slider>
        <div class="slider-percent">{{questionData.options[index].value * 100}}%</div>
      </div>
    </div>

    <div class="total-row">
      <div class="label">Total</div>
      <div class="percent" :class="{'invalid': invalid, 'is100': is100}">{{ totalPercentComputed }}%</div>
      <div class="error" v-if="invalid">
        Total cannot exceed 100%
      </div>

      <div class="error" v-if="userTriedToGoNext && is100 == false && invalid == false">
        Total must add up to 100%
      </div>
    </div>


    <div class="question-footer">
      <Btn class="next-btn" type="primary-orange" theme="white" :hasIcon="false" @click="next">Next</Btn>
    </div>
  </div>
</template>

<script>
import { Slider } from 'element-ui'
import Btn from '@/components/Btn'

export default {
  name: 'Question3',
  metaInfo() {
   // if no subcomponents specify a metaInfo.title, this title will be used
   return {
     title: 'Examine your eating',
     titleTemplate: ' %s - Question 3'
   }
  },
  props: [],
  components: {
    'el-slider': Slider,
    Btn
  },
  data() {
    return {
      userTriedToGoNext: false
    }
  },
  computed: {
    questionData() {
      return this.$store.state.DietImpact.questions[2]
    },
    totalPercentComputed() {
      let count = 0
      for (var i = 0; i < this.questionData.options.length; i++) {
        count += this.questionData.options[i].value * 100
      }
      return count
    },
    invalid() {
      return this.totalPercentComputed > 100 ? true : false
    },
    is100() {
      return this.totalPercentComputed == 100 ? true : false
    }
  },
  methods: {
    next() {
      this.userTriedToGoNext = true
      if (this.is100) {
        this.$store.commit('DietImpact/NEXT_PAGE')
        this.$parent.$parent.$refs.quiz.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    updateStore() {
      this.$store.commit('DietImpact/UPDATE_MEAT_PERCENT', this.questionData.options)
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/vars';
  .sliders {
    margin: 34px auto 0;
    // width: 93%;
    .row {
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
      padding-left: 3.5%;
      padding-right: 4%;
    }
    .title {
      font-family: $fPrimary;
      font-weight: $fwSemiBold;
      font-size: 14px;
      line-height: 17px;
      color: $cBlack;
      margin-bottom: 12px;
    }
    .el-slider {
      min-width: 243px;
    }
    .slider-percent {
      margin-left: 30px;
      font-family: $fSecondary;
      font-weight: $fwMed;
      font-size: 18px;
      line-height: 26.68px;
      text-transform: uppercase;
      text-align: right;
      color: #696969;
    }
  }
  .total-row {
    margin-top: 60px;
    margin-bottom: 40px;
    width: 100%;
    display: flex;
    position: relative;
    padding-right: 4%;
    .label,
    .percent {
      font-family: $fSecondary;
      font-weight: $fwMed;
      font-size: 18px;
      line-height: 26.68px;
      text-transform: uppercase;
    }
    .label {
      color: $cOrange;
      min-width: 243px;
      display: flex;
      justify-content: flex-end;
    }
    .percent {
      color: #696969;
      text-align: right;
      display: flex;
      justify-content: flex-end;
      flex: 1;
      transition: color 0.2s ease-out;
      &.invalid {
        color: red;
        transition: color 0.2s ease-out;
      }
      &.is100 {
        color: $cGreen;
        transition: color 0.2s ease-out;
      }
    }
  }
  .error {
    position: absolute;
    top: 40px;
    right: 0;
    font-family: $fPrimary;
    font-weight: $fwMed;
    // text-transform: uppercase;
    font-size: 14px;
    color: red;
  }
</style>
